import { store } from '@betacrew/jars-flux'
export const componentKey = "GENERAL";

const { actions } = store.reducerManager.add({
	key: componentKey,
	addedReducers: {
		setFields: (state, action) => {
			state.fields = { ...action.payload };
		},
		setLoadingState: (state, action) => {
			state.loadingState = { ...action.payload };
		},
		setSalesTaxAdminStatus: (state, action) => {
			state.salesTaxAdminStatus = action.payload;
		},
	},
	initialReducerState: {
		fields: null,
		loadingState: false,
		salesTaxAdminStatus: ''
	}
});
export const { setLoadingState, setFields, setSalesTaxAdminStatus } = actions;